<template>
    <div>
        <div class="columns">
            <div class="column">
                <toHome />
            </div>
        </div>
        <div class="columns">
            <div class="column is-half mx-6">
                <p v-if="dataTable === null">Cargar la tabla</p>
                <button class="button is-info" @click="fetchAll('?status=1')">
                    Cargar tabla
                </button>
            </div>
            <div class="column is-half mx-6">
                <p v-if="dataTable === null">
                    Cargar tabla con los saludos inactivos
                </p>
                <button class="button is-info" @click="fetchAll('?status=0')">
                    Cargar saludos eliminados
                </button>
            </div>
        </div>
        <div class="columns">
            <div class="column is-offset-1 is-three-quarters">
                <section>
                    <b-table
                        v-if="dataTable !== null"
                        :data="dataTable"
                        :columns="columns"
                        :paginated="isPaginated"
                        :per-page="perPage"
                        :current-page.sync="currentPage"
                        :debounce-search="1000"
                        aria-next-label="Next page"
                        aria-previous-label="Previous page"
                        icon-pack="fas"
                        aria-page-label="Page"
                        aria-current-label="Current page"
                        :selected.sync="selected"
                    >
                    </b-table>
                </section>
                <div
                    class="is-flex is-justify-content-space-evenly"
                    v-if="selected"
                >
                    <button
                        class="button is-danger"
                        @click="modifyCard(selected)"
                        v-if="isInactive"
                    >
                        Abrir formulario de modificaciones
                    </button>
                    <button
                        class="button"
                        @click="confirmDelCard(selected)"
                        v-if="isInactive"
                    >
                        Eliminar saludo
                    </button>
                    <button
                        class="button is-danger"
                        @click="confirmActiveCard(selected)"
                        v-if="!isInactive"
                    >
                        Activar saludo
                    </button>
                </div>
                <div
                    class="is-flex is-justify-content-space-evenly"
                    v-if="selected"
                >
                    <div class="column is-3">
                        <figure
                            class="image is-2by3 border_radius"
                            v-if="!isInactive"
                        >
                            <img
                                class="border_radius"
                                :src="selected.image"
                                :alt="selected.subtitle"
                            />
                        </figure>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns mt-6" v-if="isModify">
            <div class="column is-5 is-offset-1 has-background-white">
                <h2 class="subtitle is-size-6 has-text-weight-semibold">
                    Formulario para agregar saludo
                </h2>
                <form>
                    <b-field label="Titulo">
                        <b-input
                            id="title"
                            name="title"
                            v-model="$v.data.title.$model"
                        ></b-input>
                    </b-field>
                    <div class="error help mb-4" v-if="!$v.data.title.required">
                        Este campo es obligatorio
                    </div>
                    <span
                        class="error help mb-4 has-text-danger"
                        v-if="!$v.data.title.minLength"
                    >
                        El Titulo debe tener al menos
                        {{ $v.data.title.$params.minLength.min }}
                        caracteres.
                    </span>
                    <span
                        class="error help mb-4 has-text-danger"
                        v-if="!$v.data.title.maxLength"
                    >
                        El Titulo debe tener como máximo
                        {{ $v.data.title.$params.maxLength.max }}
                        caracteres.
                    </span>
                    <b-field label="subTitulo">
                        <b-input
                            id="subtitle"
                            name="subtitle"
                            v-model="$v.data.subtitle.$model"
                        ></b-input>
                    </b-field>
                    <div
                        class="error help mb-4"
                        v-if="!$v.data.subtitle.required"
                    >
                        Este campo es obligatorio
                    </div>
                    <span
                        class="error help mb-4 has-text-danger"
                        v-if="!$v.data.subtitle.minLength"
                    >
                        El subTitulo debe tener al menos
                        {{ $v.data.subtitle.$params.minLength.min }}
                        caracteres.
                    </span>
                    <b-field label="Categoria">
                        <b-select
                            placeholder="Selecione la categoria"
                            v-model="$v.data.category_id.$model"
                            id="category_id"
                            name="category_id"
                        >
                            <option
                                v-for="option in categorySelectable"
                                :value="option.id"
                                :key="option.id"
                            >
                                {{ option.name }}
                            </option>
                        </b-select>
                    </b-field>
                    <div
                        class="error help mb-4"
                        v-if="!$v.data.category_id.required"
                    >
                        Este campo es obligatorio
                    </div>
                    <div v-if="data.category_id.length >= 3">
                        La card esta en: <strong>{{ data.category_id }}</strong>
                    </div>
                    <div
                        class="column is-offset-1 is-flex is-justify-content-space-evenly"
                    >
                        <b-button
                            type="is-danger"
                            @click="confirmModCard(selected)"
                            >Guardar modificaciones</b-button
                        >
                    </div>
                </form>
            </div>
            <div class="column is-2">
                <figure class="image is-2by3 border_radius">
                    <img
                        class="border_radius"
                        :src="selected.image"
                        :alt="selected.subtitle"
                    />
                </figure>
            </div>
        </div>
        <theLoader v-show="loadingStatus" />
    </div>
</template>
<script>
import { UrlCards, UrlCategory, UrlDelete, UrlModify } from '../../Url'
import toHome from '../common/theImgLinkToHome'
import theLoader from '../common/theLoader'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
export default {
    components: {
        theLoader,
        toHome,
    },
    mounted() {
        this.fetchCategory()
    },
    data() {
        return {
            data: {
                title: '',
                subtitle: '',
                category_id: '',
            },
            isModify: false,
            isInactive: false,
            dataTable: null,
            isPaginated: true,
            currentPage: 1,
            perPage: 9,
            selected: null,
            categorySelectable: '',
            loadingStatus: false,
            columns: [
                {
                    field: 'id',
                    label: 'ID',
                    width: '100',
                    numeric: true,
                    searchable: true,
                },
                {
                    field: 'title',
                    label: 'Titulo',
                    searchable: true,
                },
                {
                    field: 'subtitle',
                    label: 'Sub-Titulo',
                    searchable: true,
                },
                {
                    field: 'category_id',
                    label: 'Categoria',
                    centered: true,
                    numeric: true,
                },
            ],
        }
    },
    validations: {
        data: {
            title: {
                required,
                maxLength: maxLength(5),
                minLength: minLength(4),
            },
            subtitle: {
                required,
                minLength: minLength(5),
            },
            category_id: {
                required,
            },
        },
    },
    methods: {
        fetchAll: function (query) {
            const vm = this
            fetch(UrlCards + query)
                .then((res) => res.json())
                .then((datos) => {
                    vm.dataTable = datos.data
                    if (query === '?status=1') {
                        vm.isInactive = true
                    } else {
                        vm.isInactive = false
                    }
                })
        },
        confirmDelCard(card) {
            this.$buefy.dialog.confirm({
                message: `Estas seguro de querer eliminar el saludo n° ${card.id}`,
                onConfirm: () => this.deleteCard(card),
            })
        },
        confirmActiveCard(card) {
            this.$buefy.dialog.confirm({
                message: `Estas seguro de querer activar el saludo n° ${card.id}`,
                onConfirm: () => this.activeCard(card),
            })
        },
        confirmModCard(card) {
            if (this.$v.$invalid) {
                this.$buefy.dialog.alert({
                    message:
                        '¡Ups! Aún queda información por validar. Por favor revise los datos ingresados y envíe el formulario nuevamente.',
                    confirmText: 'Entendido',
                })
            } else {
                this.$buefy.dialog.confirm({
                    message: `Estas seguro de querer modificar el saludo n° ${card.id}`,
                    onConfirm: () => this.sendData(card),
                })
            }
        },
        activeCard(card) {
            const vm = this
            let token = JSON.parse(sessionStorage.getItem('vue-session-key'))
            this.loadingStatus = true
            fetch(`${UrlDelete}/${card.id}/restore`, {
                method: 'POST',
                body: JSON.stringify(card),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token.jwt,
                },
            })
                .then((res) => res.json())
                .then(function (msg) {
                    vm.loadingStatus = false
                    vm.$buefy.dialog.alert({
                        title: 'Saludo activado exitosamente',
                        message: `${msg.data} <br> <strong> Recuerda actualizar la Tabla </strong>`,
                        type: 'is-success',
                        hasIcon: true,
                        icon: 'thumbs-up',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true,
                    })
                })
        },
        deleteCard(card) {
            const vm = this
            let token = JSON.parse(sessionStorage.getItem('vue-session-key'))
            this.loadingStatus = true
            fetch(`${UrlDelete}/${card.id}`, {
                method: 'DELETE',
                body: JSON.stringify(card),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token.jwt,
                },
            })
                .then((res) => res.json())
                .then(function (msg) {
                    vm.loadingStatus = false
                    vm.$buefy.dialog.alert({
                        title: 'Eliminación completada',
                        message: `${msg.data} <br> <strong> Recuerda actualizar la Tabla </strong>`,
                        type: 'is-success',
                        hasIcon: true,
                        icon: 'thumbs-up',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true,
                    })
                })
        },
        modifyCard(card) {
            ;(this.isModify = true),
                (this.data.title = card.title),
                (this.data.subtitle = card.subtitle)
            const Category = this.categorySelectable.filter(
                (cat) => cat.id === card.category_id
            )
            this.data.category_id = Category[0].name
        },
        fetchCategory: function () {
            const vm = this
            fetch(UrlCategory)
                .then((res) => res.json())
                .then((datos) => {
                    vm.categorySelectable = datos.data
                })
        },
        sendData(card) {
            const vm = this
            let token = JSON.parse(sessionStorage.getItem('vue-session-key'))
            this.loadingStatus = true
            fetch(`${UrlModify}/${card.id}`, {
                method: 'PUT',
                body: JSON.stringify(this.data),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token.jwt,
                },
            })
                .then((res) => res.json())
                .then(function (msg) {
                    vm.loadingStatus = false
                    if (msg.error) {
                        vm.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${msg.error}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true,
                        })
                    } else {
                        vm.$buefy.dialog.alert({
                            title: 'Edición completada',
                            message: `${msg.data} <br> <strong>Recuerda actualizar la Tabla </strong>`,
                            type: 'is-success',
                            hasIcon: true,
                            icon: 'thumbs-up',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true,
                        })
                    }
                })
        },
    },
}
</script>
<style lang="scss">
.border_radius {
    border-radius: 4px;
}
</style>
